import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    // h-screen + overflow-hidden gives every descendant a real, bounded
    // height to inherit. min-h-screen alone won't do this — it only sets a
    // floor, so h-full further down the tree has nothing to be "full" of.
    <div className="h-screen bg-slate-100 overflow-hidden">
      {/* Sidebar (assumed fixed-position, offset via md:ml-72 below) */}
      <Sidebar open={sidebarOpen} />

      {/* Main Content column */}
      <div className="md:ml-72 h-screen flex flex-col transition-all duration-300">
        {/* Header - fixed height, sits at the top, never scrolls */}
        <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

        {/*
          Page Content - flex-1 lets this fill all remaining height below
          the header. min-h-0 is required alongside flex-1: without it,
          flex children refuse to shrink below their content size, and the
          page below will overflow the screen instead of scrolling
          internally. overflow-hidden here means only the page's own inner
          scroll container (e.g. a table body) scrolls, not this wrapper.

          No padding here on purpose — each page applies its own p-3/md:p-6
          so it can control its own layout (e.g. Dashboard's summary cards
          need different spacing than a full-height table page).
        */}
        <main className="flex-1 min-h-0 overflow-hidden">{children}</main>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default MainLayout;